import React from 'react'
import Slider from 'react-slick'
import classNames from 'classnames'
import Img from 'gatsby-image'

import MainSectionLayout from '@/main-section-layout'
import PageTopBar from '@/page-top-bar'
import LargeText from '@/large-text'
import BrandLogos from '@/brand-logos'
import BrandInfo from './brand-info'

import './styles.css'

const SectionCaseStudies = ({ data }) => {
  const settings = {
    dots: true,
    slidesToShow: 1,
    arrows: false,
    fade: true,
    autoplay: true,
    autoplaySpeed: 5000
  }

  return (
    <PageTopBar iconName="check" text="Case studies">
      <MainSectionLayout
        noLogo
        title="Case studies"
        className="overflow-hidden"
      >
        <div className="mb6 mb5-m relative">
          <Slider {...settings}>
            <Img sizes={data.CaseStudies1.sizes} alt="" />
            <Img sizes={data.CaseStudies2.sizes} alt="" />
            <Img sizes={data.CaseStudies3.sizes} alt="" />
            <Img sizes={data.CaseStudies4.sizes} alt="" />
          </Slider>

          <div
            className={classNames({
              'absolute top-100 left-0 ml3 ml4-l translateY--50': true,
              'w270 h270 white gold-gradient br-100 pa2 pa3-m z-2 tc': true,
              'flex flex-column items-center justify-center': true
            })}>
            <div className="f11 f6-m f4-l mb1">Case Studies</div>
            <div className="f13 f9-m f6-l">Proven track record</div>
          </div>
        </div>

        <div className="ph4-l pt3 pt0-m mb6 w-100 w-60-m ml-auto">
          <LargeText align="right">
            We've worked with diverse clients,
            located across the globe. <br/>
            The stories that we have shared below provide an
            insight into how we're enabling beauty pageants to
            bring their digital presence to the next level.
          </LargeText>
        </div>

        <BrandLogos />

        <BrandInfo
          brandName="Miss Finland"
          brandText="Next Miss has cooperated closely with Miss Finland since February 2017. From the day 1, the results have been amazing. Miss Finland organisation has given valuable insights during the years for the development of Next Miss Platform. Next Miss is the exclusive partner of all digital services of Miss Finland."
          mainImgSrc={data.phoneMsFinland.sizes}
          logoSrc={data.logoMS.sizes}
          avatarSrc={data.avatarFinland.sizes}
          personName="Sunneva Kantola"
          personStatus={
            <span>
              Country Manager <br/>
              Miss Universe Finland
            </span>
          }
          personText="“Our organisation has worked with Next Miss team for the past 3 years. Results have been amazing. I can truly recommend Next Miss to any beauty pageant organisation.”"
          yearStarted="2017"
          votes="15"
          castings="2"
          ratings="2"
        />

        <BrandInfo
          brandName="Miss South Africa"
          brandText="Miss South Africa contacted Next Miss in late 2018 to bring their digital processes to the next level. Next Miss and Miss South Africa cooperated closely truoughtout the year 2019. PriceWaterhouseCoopers SA was assessing the process and the casting and voting results exceeded the expectations."
          mainImgSrc={data.phoneMsAfrica.sizes}
          logoSrc={data.logoSA.sizes}
          avatarSrc={data.avatarAfrica.sizes}
          personName="Gareth Flusk"
          personStatus={
            <span>
              Group Content <br />
              Miss Universe South Africa
            </span>
          }
          personText="“We run the casting and voting in 2019 using Next Miss toolkit. We received a record amount of applications and we are super happy with the service. Thank you Next Miss team.”"
          yearStarted="2019"
          votes="1"
          castings="1"
          ratings="1"
        />

        <BrandInfo
          brandName="Miss USSR UK"
          brandText="The partnership between Next Miss and Miss USSR UK started in 2017. The Miss USSR UK team has been very successful in using the Next Miss tools and promoting the votes. All votes have gone viral in social medias. In addition, the votes have generated significant traction and revenue time after time."
          mainImgSrc={data.phoneMsUssr.sizes}
          logoSrc={data.logoUSSR.sizes}
          avatarSrc={data.avatarUssr.sizes}
          personName="Julia Titova"
          personStatus={
            <span>
              CEO & Founder <br />
              Miss USSR UK
            </span>
          }
          personText="“We have been using Next Miss for 3 years and made excellent results with engagement and new revenue. The platform is very easy to use and I highly recommend it for others.”"
          yearStarted="2017"
          votes="10"
          castings="2"
          ratings="1"
        />

        <BrandInfo
          brandName="Miss Armenia"
          brandText="Next Miss team met with Miss Armenia team at Miss Universe 2018 final in Thailand. Next Miss supported Miss Armenia to run their first ever digital voting in 2019 and it was an instant success. The popularity of the vote surprised both parties and the contestants were actively promoting the vote on social."
          mainImgSrc={data.phoneMsArmenia.sizes}
          logoSrc={data.logoArmenia.sizes}
          avatarSrc={data.avatarArmenia.sizes}
          personName="Gohar Harutyunyan"
          personStatus={
            <span>
              Country Manager <br />
              Miss Universe Armenia
            </span>
          }
          personText="“Miss Universe Armenia used Next Miss tools to run our people’s choice voting in 2019. For us it was very easy to work with Next Miss team and the voting generated excellent traction.”"
          yearStarted="2019"
          votes="1"
        />
      </MainSectionLayout>
    </PageTopBar>
  )
}

export default SectionCaseStudies



// WEBPACK FOOTER //
// ./src/components/section-case-studies/section-case-studies.js